export default "__VITE_ASSET__6a2f6825__"